import { Typography } from 'antd';
import { type ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

const Paragraph = ({ children, ...rest }: ComponentProps<typeof Typography.Paragraph>) => {
  const { t } = useTranslation();
  return <Typography.Paragraph {...rest}>{typeof children === 'string' ? t(children) : children}</Typography.Paragraph>;
};

export default Paragraph;
